function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageresize/imageresizeediting
 */
import { Plugin } from 'ckeditor5/src/core';
import ImageUtils from '../imageutils';
import ResizeImageCommand from './resizeimagecommand';
/**
 * The image resize editing feature.
 *
 * It adds the ability to resize each image using handles or manually by
 * {@link module:image/imageresize/imageresizebuttons~ImageResizeButtons} buttons.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageResizeEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageResizeEditing, _Plugin);

  var _super = _createSuper(ImageResizeEditing);

  /**
   * @inheritDoc
   */
  function ImageResizeEditing(editor) {
    var _this;

    _classCallCheck(this, ImageResizeEditing);

    _this = _super.call(this, editor);
    editor.config.define('image', {
      resizeUnit: '%',
      resizeOptions: [{
        name: 'resizeImage:original',
        value: null,
        icon: 'original'
      }, {
        name: 'resizeImage:25',
        value: '25',
        icon: 'small'
      }, {
        name: 'resizeImage:50',
        value: '50',
        icon: 'medium'
      }, {
        name: 'resizeImage:75',
        value: '75',
        icon: 'large'
      }]
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageResizeEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var resizeImageCommand = new ResizeImageCommand(editor);

      this._registerSchema();

      this._registerConverters('imageBlock');

      this._registerConverters('imageInline'); // Register `resizeImage` command and add `imageResize` command as an alias for backward compatibility.


      editor.commands.add('resizeImage', resizeImageCommand);
      editor.commands.add('imageResize', resizeImageCommand);
    }
    /**
     * @private
     */

  }, {
    key: "_registerSchema",
    value: function _registerSchema() {
      if (this.editor.plugins.has('ImageBlockEditing')) {
        this.editor.model.schema.extend('imageBlock', {
          allowAttributes: 'width'
        });
      }

      if (this.editor.plugins.has('ImageInlineEditing')) {
        this.editor.model.schema.extend('imageInline', {
          allowAttributes: 'width'
        });
      }
    }
    /**
     * Registers image resize converters.
     *
     * @private
     * @param {'imageBlock'|'imageInline'} imageType The type of the image.
     */

  }, {
    key: "_registerConverters",
    value: function _registerConverters(imageType) {
      var editor = this.editor; // Dedicated converter to propagate image's attribute to the img tag.

      editor.conversion.for('downcast').add(function (dispatcher) {
        return dispatcher.on("attribute:width:".concat(imageType), function (evt, data, conversionApi) {
          if (!conversionApi.consumable.consume(data.item, evt.name)) {
            return;
          }

          var viewWriter = conversionApi.writer;
          var figure = conversionApi.mapper.toViewElement(data.item);

          if (data.attributeNewValue !== null) {
            viewWriter.setStyle('width', data.attributeNewValue, figure);
            viewWriter.addClass('image_resized', figure);
          } else {
            viewWriter.removeStyle('width', figure);
            viewWriter.removeClass('image_resized', figure);
          }
        });
      });
      editor.conversion.for('upcast').attributeToAttribute({
        view: {
          name: imageType === 'imageBlock' ? 'figure' : 'img',
          styles: {
            width: /.+/
          }
        },
        model: {
          key: 'width',
          value: function value(viewElement) {
            return viewElement.getStyle('width');
          }
        }
      });
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ImageUtils];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageResizeEditing';
    }
  }]);

  return ImageResizeEditing;
}(Plugin);

export { ImageResizeEditing as default };